import styled from '@emotion/styled'
import { FunctionComponent } from 'react'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { Icon } from '~/components/Icon'
import { TrackingLabel } from '~/components/layout/ProductTrackingIntegration'
import { Toggle } from '~/components/Toggle'

type ToggleWithTextProps = {
  title: string
  checked: boolean
  onChange: (newValue: boolean) => void
  description?: string
  trackingLabel: TrackingLabel
  disabled?: boolean
  errorMessage?: string
}

const ToggleTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`
const ToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

const ToggleContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const ToggleText = styled.span`
  ${Fonts.H2};
  ${Fonts.colors.Jet};
  font-weight: 500;
  align-items: center;
  display: inline-flex;
  gap: 4px;
`

const SubTitle = styled.span`
  ${Fonts.P2};
  ${Fonts.colors.Hurricane};
`
const DeviceErrorMessageWrapper = styled.span`
  display: inline-flex;
  color: ${Colors.Alert};
  align-items: center;
  gap: 4px;
`

const DeviceErrorMessage = ({ message }: { message?: string }) => (
  <DeviceErrorMessageWrapper>
    <Icon width={'16px'} name={'alert'} />
    {message}
  </DeviceErrorMessageWrapper>
)

export const ToggleWithText: FunctionComponent<ToggleWithTextProps> = ({ title, description, onChange, trackingLabel, disabled, errorMessage, checked }) => {
  const handleClick = () => {
    onChange && onChange(!checked)
  }
  return (
    <ToggleWrapper>
      <Toggle value={checked} onClick={handleClick} trackingLabel={trackingLabel} disabled={disabled} />
      <ToggleContentWrapper>
        <ToggleTitleWrapper>
          <ToggleText>{title}</ToggleText> {errorMessage && <DeviceErrorMessage message={errorMessage} />}
        </ToggleTitleWrapper>
        {description && <SubTitle>{description}</SubTitle>}
      </ToggleContentWrapper>
    </ToggleWrapper>
  )
}
